<template>
  <div>
    <button
      class="btn multi"
      v-bind:class="{
        rounded: rounded,
        bordered: bordered,
        'form-control': rounded | bordered,
        'input-text': rounded | bordered,
      }"
      v-show="!isEdit"
      @click="doEdit"
      @focus="doEdit"
    >
      {{ value | thousandSeparator }}
    </button>
    <input
      type="number"
      ref="edit"
      class="form-control multi"
      v-model="val"
      v-show="isEdit"
      v-bind:class="{ rounded: rounded, bordered: bordered }"
      @blur="noEdit"
      @keyup="keyUp"
    />
  </div>
</template>
<script>
export default {
  name: "ButtonEditInput",
  props: {
    index: Number,
    value: Number,
    rounded: Boolean,
    bordered: Boolean,
    control: Boolean,
  },
  created() {
    this.init();
  },
  data() {
    return {
      isEdit: false,
      val: 0,
    };
  },
  methods: {
    init() {
      this.val = this.generateValue();
    },
    generateValue() {
      switch (typeof this.value) {
        case "undefined":
          return 0;
        case "string":
          return parseInt(this.value);
        case "number":
          return this.value;
      }
    },
    doEdit() {
      console.log("do edit");
      this.init();
      this.isEdit = true;
      this.$refs.edit.focus();
    },
    noEdit() {
      console.log("no edit");
      const newVal = parseInt(this.val);
      this.isEdit = false;
      // this.value = newVal;
      console.log(newVal);
      if (!this.index) {
        this.$emit("updateValue", 0, newVal);
        return;
      }
      this.$emit("updateValue", this.index, newVal);
    },
    keyUp(e) {
      console.log("key up");
      this.value = this.generateValue();
      this.$emit("doKeyUp", this.value);
      if (e.keyCode == 13) {
        this.noEdit();
      }
    },
  },
};
</script>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
.multi {
  padding: 3px;
  width: 100%;
  text-align: right;
  border-radius: 0;
}
.input-text {
  padding: 0.375rem 0.75rem;
}
</style>